import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import Icon from 'react-native-vector-icons/Ionicons';
import { MARKETPLACE_COLORS } from '@/constants/residents/marketplaceColors';
import { homeStrings } from '@/constants/residents/strings';

interface BulletinCardProps {
  unreadCount: number;
  onPress: () => void;
}

export const BulletinCard: React.FC<BulletinCardProps> = ({ unreadCount, onPress }) => {
  // Use centralized strings that match iOS exactly
  const getText = () => {
    switch (unreadCount) {
      case 0:
        return homeStrings.actions.bulletins.noNew;
      case 1:
        return homeStrings.actions.bulletins.newSingular;
      default:
        return homeStrings.actions.bulletins.newPlural(unreadCount);
    }
  };

  const getIconStyle = () => {
    if (unreadCount === 0) {
      return {
        backgroundColor: MARKETPLACE_COLORS.white10Percent,
        iconColor: MARKETPLACE_COLORS.accentBlueSolid,
      };
    } else {
      return {
        backgroundColor: MARKETPLACE_COLORS.accentRed,
        iconColor: MARKETPLACE_COLORS.textPrimary,
      };
    }
  };

  const iconStyle = getIconStyle();
  
  return (
    <TouchableOpacity 
      style={styles.card} 
      onPress={onPress} 
      accessibilityRole="button"
      accessibilityLabel={getText()}
    >
      <View style={styles.content}>
        <View style={[styles.icon, { backgroundColor: iconStyle.backgroundColor }]}>
          <Icon 
            name="megaphone-outline" 
            size={20} 
            color={iconStyle.iconColor} 
          />
        </View>
        <Text style={styles.text}>
          {getText()}
        </Text>
        <Icon 
          name="chevron-forward" 
          size={24} 
          color={MARKETPLACE_COLORS.inputBorder} 
        />
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  card: {
    backgroundColor: MARKETPLACE_COLORS.cardBackground,
    borderRadius: 16,
    padding: 20,
  },
  content: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  icon: {
    width: 40,
    height: 40,
    borderRadius: 20,
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 12,
  },
  text: {
    flex: 1,
    fontSize: 13,
    fontWeight: '500',
    color: MARKETPLACE_COLORS.textPrimary,
  },
});
